export default __webpack_public_path__ + "images/_/_/_/_/node_modules/@redash/viz/node_modules/leaflet/dist/images/marker-shadow.png";